import React, { useEffect, useState } from 'react';
import { useLanguage } from '../LanguageContext';
import { Globe, Menu, X } from 'lucide-react';
export const Header = () => {
  const {
    language,
    setLanguage,
    t
  } = useLanguage();
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollTo = (id: string) => {
    setMobileMenuOpen(false);
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white/90 backdrop-blur-md shadow-sm py-3' : 'bg-transparent py-5'}`} data-id="element-49">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex justify-between items-center" data-id="element-50">
        <div className="flex items-center gap-2 cursor-pointer" onClick={() => window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })} data-id="element-51">
          <div className="w-10 h-10 rounded-full bg-indigo-600 flex items-center justify-center text-white font-bold text-xl" data-id="element-52">
            MR
          </div>
          <span className="font-bold text-xl text-slate-900 tracking-tight" data-id="element-53">
            Mora Rebori
          </span>
        </div>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8" data-id="element-54">
          <button onClick={() => scrollTo('program')} className="text-slate-600 hover:text-indigo-600 font-medium transition-colors" data-id="element-55">
            {t.nav.program}
          </button>
          <button onClick={() => scrollTo('testimonial')} className="text-slate-600 hover:text-indigo-600 font-medium transition-colors" data-id="element-56">
            {t.nav.testimonial}
          </button>
          <button onClick={() => scrollTo('faq')} className="text-slate-600 hover:text-indigo-600 font-medium transition-colors" data-id="element-57">
            {t.nav.faq}
          </button>

          <div className="flex items-center gap-2 bg-slate-100 p-1 rounded-full" data-id="element-58">
            <button onClick={() => setLanguage('en')} className={`px-3 py-1 rounded-full text-sm font-medium transition-all ${language === 'en' ? 'bg-white shadow-sm text-indigo-600' : 'text-slate-500 hover:text-slate-700'}`} data-id="element-59">
              EN
            </button>
            <button onClick={() => setLanguage('es')} className={`px-3 py-1 rounded-full text-sm font-medium transition-all ${language === 'es' ? 'bg-white shadow-sm text-indigo-600' : 'text-slate-500 hover:text-slate-700'}`} data-id="element-60">
              ES
            </button>
          </div>

          <button onClick={() => scrollTo('booking')} className="bg-indigo-600 hover:bg-indigo-700 text-white px-6 py-2.5 rounded-full font-semibold transition-all shadow-md hover:shadow-lg transform hover:-translate-y-0.5" data-id="element-61">
            {t.nav.book}
          </button>
        </nav>

        {/* Mobile Menu Toggle */}
        <button className="md:hidden text-slate-600" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} data-id="element-62">
          {mobileMenuOpen ? <X size={28} data-id="element-63" /> : <Menu size={28} data-id="element-64" />}
        </button>
      </div>

      {/* Mobile Nav */}
      {mobileMenuOpen && <div className="md:hidden absolute top-full left-0 right-0 bg-white shadow-lg border-t border-slate-100 py-4 px-4 flex flex-col gap-4" data-id="element-65">
          <button onClick={() => scrollTo('program')} className="text-left text-slate-600 font-medium py-2" data-id="element-66">
            {t.nav.program}
          </button>
          <button onClick={() => scrollTo('testimonial')} className="text-left text-slate-600 font-medium py-2" data-id="element-67">
            {t.nav.testimonial}
          </button>
          <button onClick={() => scrollTo('faq')} className="text-left text-slate-600 font-medium py-2" data-id="element-68">
            {t.nav.faq}
          </button>
          <div className="flex items-center gap-4 py-2" data-id="element-69">
            <Globe size={20} className="text-slate-400" data-id="element-70" />
            <button onClick={() => {
          setLanguage('en');
          setMobileMenuOpen(false);
        }} className={`font-medium ${language === 'en' ? 'text-indigo-600' : 'text-slate-500'}`} data-id="element-71">
              English
            </button>
            <span className="text-slate-300" data-id="element-72">|</span>
            <button onClick={() => {
          setLanguage('es');
          setMobileMenuOpen(false);
        }} className={`font-medium ${language === 'es' ? 'text-indigo-600' : 'text-slate-500'}`} data-id="element-73">
              Español
            </button>
          </div>
          <button onClick={() => scrollTo('booking')} className="bg-indigo-600 text-white px-6 py-3 rounded-xl font-semibold text-center w-full mt-2" data-id="element-74">
            {t.nav.book}
          </button>
        </div>}
    </header>;
};